import React, { useEffect, useRef, useState } from "react";
import { absoluteUrl, copyToClipboard } from "../_helper";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  toggleSidebarCollapse,
  toggleSidebarCollapseForMobile,
} from "../Redux/UISlice";
import { logoutAction } from "../Redux/Auth/AuthActions";
import { USER_TYPES, USER_TYPES_CATEGORIES } from "../constants/globals";
import { capitalize } from "lodash";
import CopyAnimationComponent from "../assets/lottie/CopyAnimation/CopyAnimationComponent";
import { getPartnerProfileImage } from "../apis";

const Header = () => {
  const dispatch = useDispatch();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Getting User Data from Redux Store
  const { loggedInUser } = useSelector((state) => state.Auth);
  const { sales_link } = loggedInUser?.data?.model?.client || {};
  const { clientCategoryName } = loggedInUser?.data?.model || {};
  const currentUserType = loggedInUser?.data?.model?.user_type_id;
  const [profilePhoto, setProfilePhoto] = useState(null);

  const currentClientCategory =
    loggedInUser?.data?.model?.client?.client_category_id;

  const getKeyByValue = (obj, value) => {
    return Object.keys(obj).find((key) => obj[key] === value);
  };
  const userRole = getKeyByValue(USER_TYPES, currentUserType);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getPartnerProfileImage()
      .then((response) => {
        setProfilePhoto(response.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div
      id="header"
      data-fixed=""
      className="mdk-header js-mdk-header mb-0 w-100"
    >
      <div className="mdk-header__content">
        <nav
          id="default-navbar"
          className="navbar navbar-expand navbar-dark tw-bg-secondary m-0"
        >
          <div className="container-fluid">
            <button
              onClick={() => {
                dispatch(toggleSidebarCollapse());
                dispatch(toggleSidebarCollapseForMobile());
              }}
              className="d-inline tw-w-2 tw-p-0 tw-pe-4"
              data-toggle="sidebar"
              type="button"
            >
              <span className="material-icons tw-text-[#ffffff80] tw-text-2xl">
                menu
              </span>
            </button>

            <Link to={"/"}>
              <img
                src={absoluteUrl("imgs/logo.png")}
                className="!tw-w-12 max-sm:!tw-w-10 sm:tw-ms-3 tw-pt-1"
                alt="UNITERS ACADEMY"
              />
            </Link>
            <h4
              className="tw-text-white !tw-m-0 tw-font-semibold tw-text-[15px] max-sm:!tw-text-[12px]"
              style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
            >
              UNITERS ACADEMY
            </h4>

            {!(
              currentClientCategory === USER_TYPES_CATEGORIES.NEWCOMER ||
              currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_ONLY
            ) && (
              <div className="navbar-brand md:tw-ml-20 tw-m-0 md:tw-text-[19px] tw-text-[14px] d-flex align-items-center my-2 !tw-hidden md:!tw-block ">
                {sales_link && (
                  <CopyAnimationComponent
                    onClick={copyToClipboard}
                    link={sales_link}
                    title={"Copy Sale Link:"}
                  />
                )}
              </div>
            )}

            <div className="flex"></div>

            <ul className="nav navbar-nav flex-nowrap">
              <li className="nav-item dropdown ml-1 ml-md-3">
                <div className="c-white tw-hidden lg:tw-block">
                  <span>{userRole && capitalize(userRole)} </span>
                  <span>
                    {clientCategoryName && "| "}
                    {clientCategoryName &&
                      capitalize(clientCategoryName)} -{" "}
                  </span>
                  <span className="mr-3">
                    {loggedInUser?.data?.model?.first_name}{" "}
                    {loggedInUser?.data?.model?.second_name}{" "}
                  </span>
                </div>
                <div className="tw-flex lg:tw-hidden tw-text-white tw-mr-3 tw-text-sm">
                  Hi {loggedInUser?.data?.model?.first_name}
                </div>
                <div
                  className={`dropdown ${isDropdownOpen ? "show" : ""}`}
                  ref={dropdownRef}
                >
                  <div
                    className={`tw-w-12 tw-h-12 tw-cursor-pointer ${
                      !profilePhoto && "tw-bg-[#eee]"
                    } tw-rounded-full`}
                    onClick={toggleDropdown}
                  >
                    {profilePhoto && (
                      <img
                        src={profilePhoto}
                        alt="Avatar"
                        className="tw-w-full tw-h-full tw-object-cover tw-rounded-full"
                        width="40"
                        height="40"
                        style={{ objectFit: "cover" }}
                      />
                    )}
                  </div>
                  <div
                    className={`dropdown-menu !tw-end-1 tw-top-[48px] tw-text-[#39444DD6] dropdown-menu-right ${
                      isDropdownOpen ? "show" : ""
                    }`}
                  >
                    {currentUserType === USER_TYPES.PARTNER && (
                      <Link
                        onClick={() => setDropdownOpen(false)}
                        to={"/myPrfoile"}
                        className="hover:!tw-bg-primary hover:!tw-no-underline tw-w-full tw-inline-block hover:!tw-text-white tw-px-5 tw-py-1 tw-text-start"
                      >
                        My Profile
                      </Link>
                    )}
                    {/* {currentUserType === USER_TYPES.PARTNER && (
                      <button className="hover:!tw-bg-primary hover:!tw-text-white tw-w-full tw-px-5 tw-py-1 tw-text-start">
                        My Subscriptions
                      </button>
                    )} */}
                    <button
                      className="hover:!tw-bg-red-500 hover:!tw-text-white tw-w-full tw-px-5 tw-py-1 tw-text-start"
                      onClick={() => dispatch(logoutAction())}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
